import { UploadFile } from "ngx-uploader";
import { TreeNode } from "primeng/api";

export interface CheckImageNameAndExistenceResponse {
  isFileNameExist?: boolean;
  imageNameIncorrect?: boolean;
  userName: string;
  portalVersion: string;
}
export type FieldsType = "fileName" | "src";

export type FieldsAndFlagType = Record<FieldsType, boolean>;

export interface UploadImageFile extends UploadFile {
  isExisting?: boolean;
  imageNameIncorrect?: boolean;
  variables: FieldsAndFlagType;
  justUpload?: boolean;
  url?: string;
}

export interface ImageFileSimplified {
  name: string;
  url?: string;
  path?: string;
}

export interface UseImage {
  fileName: string;
  tmpFileName: string;
  variableName: string;
  variableValue: string;
}

/**
 * IMAGE TREE NODE
 */
export class ImageTreeNode implements TreeNode {
  public label: string;
  public data: string;
  public expandedIcon: string;
  public collapsedIcon: string;
  public icon: string;
  public children: Array<ImageTreeNode>;
  public leaf: boolean;
  public parent?: ImageTreeNode;
  public selectable: boolean;

  constructor({ label, type }: { label: string; type: TreeNodeType }) {
    this.label = label;

    switch (type) {
      case "d":
        this.expandedIcon = "pi pi-folder-open";
        this.collapsedIcon = "pi pi-folder";
        this.data = null;
        this.leaf = false;
        this.selectable = false;
        break;
      case "f":
        this.icon = "pi pi-image";
        this.data = null;
        this.selectable = true;
        break;
    }
  }
}

/**
 * TREE NODE TYPE
 * possible 'f' file or 'd' directory
 */
export type TreeNodeType = "f" | "d";

export interface ImageTreeNodeResponse {
  label: string;
  type: TreeNodeType;
}

export interface DirStructureResponse {
  directoryStructure: Array<ImageTreeNodeResponse>;
}

export class SelectedImage {
  src: string;
  templateVariableValue: string;

  constructor(src, templateVariable) {
    this.src = src;
    this.templateVariableValue = templateVariable;
  }
}

export interface UploadImageInitialState {
  // selectedImage: SelectedImage,
  templateVariable: string;
  droppedFiles: FileList,
}


export type ImageOuterHTMLType ={
  stylesCallback: () => string;
  inputId: string;
  buttonId:string;
  imageElementAsString: string;
  imageContainerClass:string;
}
